// src/components/HighlightsLowlights.js
import React from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa'; // Importing icons
import Header from './Header';
import Footer from './Footer';

const HighlightsLowlights = ({ propertyValuation, pageNumber }) => {
  const propertyDetails = propertyValuation?.propertyAttributes?.propertyDetails;
  const highlights = propertyValuation?.propertyValuation?.propertyHighlights || [];
  const lowlights = propertyValuation?.propertyValuation?.propertyLowlights || [];

  // Currency formatter function for $xxx,xxx with no decimal places (AUD)
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  // Calculate Totals
  const totalHighlightsSum = highlights.reduce((sum, item) => sum + item.value, 0);
  const totalLowlightsSum = lowlights.reduce((sum, item) => sum + item.value, 0);

  return (
    <>
      {/* Highlights and Lowlights Page */}
      <div className={`bg-gray-200 w-[794px] h-[1123px] flex flex-col page-break`}>
        <Header pageNumber={pageNumber} propertyDetails={propertyDetails} />

        <div className="flex-grow p-8">
          <h2 className="text-2xl font-semibold mb-6">Property Highlights and Lowlights</h2>

          {/* Pros (Highlights) Section */}
          <div className="mb-12">
            <div className="flex items-center mb-4">
              <FaCheckCircle className="text-green-600 text-2xl mr-2" aria-label="Highlight" />
              <h3 className="text-xl font-semibold text-green-600">Pros</h3>
            </div>
            <div className="w-full overflow-x-auto">
              <table className="min-w-full table-fixed border-collapse rounded-lg">
                <thead>
                  <tr className="bg-green-100">
                    <th className="px-2 py-2 text-left rounded-tl-lg w-[30%]">Attribute</th>
                    <th className="px-2 py-2 text-right w-[15%]">Value</th>
                    <th className="px-2 py-2 text-left rounded-tr-lg w-[55%]">Description</th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {highlights.map((highlight, index) => (
                    <tr key={index}>
                      <td className="border-t border-b border-gray-300 px-2 py-2 font-medium w-[30%]">
                        {highlight.name}
                      </td>
                      <td className="border-t border-b border-gray-300 px-2 py-2 text-right w-[15%]">
                        {highlight.value !== 0 ? formatCurrency(highlight.value) : '—'}
                      </td>
                      <td className="border-t border-b border-gray-300 px-2 py-2 text-sm text-gray-700 w-[55%]">
                        {highlight.description}
                      </td>
                    </tr>
                  ))}
                  {/* Total Row */}
                  <tr className="font-semibold">
                    <td className="border-t border-gray-300 px-2 py-2 rounded-bl-lg w-[30%]">Total</td>
                    <td className="border-t border-gray-300 px-2 py-2 text-right w-[15%]">
                      {formatCurrency(totalHighlightsSum)}
                    </td>
                    <td className="border-t border-gray-300 px-2 py-2 rounded-br-lg w-[55%]"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Cons (Lowlights) Section */}
          <div>
            <div className="flex items-center mb-4">
              <FaTimesCircle className="text-red-600 text-2xl mr-2" aria-label="Lowlight" />
              <h3 className="text-xl font-semibold text-red-600">Cons</h3>
            </div>
            <div className="w-full overflow-x-auto">
              <table className="min-w-full table-fixed border-collapse rounded-lg">
                <thead>
                  <tr className="bg-red-100">
                    <th className="px-4 py-2 text-left rounded-tl-lg w-[30%]">Attribute</th>
                    <th className="px-4 py-2 text-right w-[15%]">Value</th>
                    <th className="px-4 py-2 text-left rounded-tr-lg w-[55%]">Description</th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {lowlights.map((lowlight, index) => (
                    <tr key={index}>
                      <td className="border-t border-b border-gray-300 px-4 py-2 font-medium w-[30%]">
                        {lowlight.name}
                      </td>
                      <td className="border-t border-b border-gray-300 px-4 py-2 text-right w-[15%]">
                        {lowlight.value !== 0 ? formatCurrency(lowlight.value) : '—'}
                      </td>
                      <td className="border-t border-b border-gray-300 px-4 py-2 text-sm text-gray-700 w-[55%]">
                        {lowlight.description}
                      </td>
                    </tr>
                  ))}
                  {/* Total Row */}
                  <tr className="font-semibold">
                    <td className="border-t border-gray-300 px-4 py-2 rounded-bl-lg w-[30%]">Total</td>
                    <td className="border-t border-gray-300 px-4 py-2 text-right w-[15%]">
                      {formatCurrency(totalLowlightsSum)}
                    </td>
                    <td className="border-t border-gray-300 px-4 py-2 rounded-br-lg w-[55%]"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default HighlightsLowlights;
